module.exports = __webpack_public_path__ + "img/FSA Tips Infographic.0b199b59.jpeg";